import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard,AuthGuardLogin } from './core/gaurds/auth.gaurd';
import { LayoutComponent } from './SmartBook.Other/layout/layout.component';

const appRoutes: Routes = [
    {
        path: 'login',
        loadChildren: () => import('./SmartBook.Other/login/login.module').then(m => m.LoginModule),
        data: { reuse: false }
    },
    {
        path: 'main',
        component: LayoutComponent,
        children: [{
            path: 'dashboard',
            loadChildren: () => import('./SmartBook.Other/dashboard/dashboard.module').then(m => m.DashboardModule),
            canActivate: [AuthGuard],
            data : { title : 'Dashboard'}
        },
        {
            path: 'hr_employee_information',
            loadChildren: () => import('./HR.EmployeeInformation/hr_employee_information.module').then(m => m.HREmployeeInformationModule),
            canActivate: [AuthGuard]
        },
        {
            path: 'hr_insurances_and_other',
            loadChildren: () => import('./HR.InsurancesAndOther/hr_insurances_and_other.module').then(m => m.HRInsurancesAndOtherModule),
            canActivate: [AuthGuard]
        },
        {
            path: 'hr_salary_calculation',
            loadChildren: () => import('./HR.SalaryCalculation/hr_salary_calculation.module').then(m => m.HRSalaryCalculationModule),
            canActivate: [AuthGuard]
        },
        {
            path: 'hr_timekeeping',
            loadChildren: () => import('./HR.Timekeeping/hr_timekeeping.module').then(m => m.HRTimeKeepingModule),
            canActivate: [AuthGuard]
        },
        {
            path: 'hr_setup',
            loadChildren: () => import('./HR.Setup/hr_setup.module').then(m => m.HRSetupModule),
            canActivate: [AuthGuard]
        },
        {
            path: 'hr_general',
            loadChildren: () => import('./HR.General/hr_general.module').then(m => m.HRGeneralModule),
            canActivate: [AuthGuard]
        }]
    },
    { path: '',
    redirectTo: 'main/dashboard',
    pathMatch: 'full' }
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, {
    // NOTICE: If you use `reuse-tab` component and turn on keepingScroll you can set to `disabled`
    // Pls refer to https://ng-alain.com/components/reuse-tab
    scrollPositionRestoration: 'top',
    relativeLinkResolution: 'legacy'
})
      ],
      exports: [RouterModule]
})
export class AppRoutingModule { }